import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=6462b5da&scoped=true&"
import script from "./teacher.vue?vue&type=script&lang=js&"
export * from "./teacher.vue?vue&type=script&lang=js&"
import style0 from "./teacher.vue?vue&type=style&index=0&id=6462b5da&scoped=true&lang=css&"
import style1 from "./teacher.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462b5da",
  null
  
)

export default component.exports